import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-page-header-selections',
  templateUrl: './page-header-selections.component.html',
  styleUrls: ['./page-header-selections.component.scss']
})
export class PageHeaderSelectionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  @Input() pageId:number = 1;

  @Input() headerSelections:string[];
  @Input() title: string;

  @Output() pageChanged:EventEmitter<number> = new EventEmitter();

  changePageNumber(){
    this.pageChanged.emit(this.pageId);
  }
}
